import { render } from "./RotateHandler.vue?vue&type=template&id=9a549510&scoped=true&ts=true"
import script from "./RotateHandler.vue?vue&type=script&lang=ts"
export * from "./RotateHandler.vue?vue&type=script&lang=ts"

import "./RotateHandler.vue?vue&type=style&index=0&id=9a549510&lang=scss&scoped=true"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a549510"]])

export default __exports__